import { createSelector } from 'reselect'
import getCustomersData from './getCustomersData'

export default createSelector(
  getCustomersData,
  (customers) => (customers || []).map((customer) => ({ key: customer.id, label: customer.title })),
)
